import "./App.css";
import Search from "./components/Search";
// import { Route,Router, Switch } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <h1>MealsDB</h1>
      <Search />

    </div>
  );
}

export default App;
